import { MODULES, vuexName } from "@/store/utils";
import { useStore } from "vuex";
export interface DeviceSettingModalProps {
  isMicEnabled: boolean;
  isCamEnabled: boolean;
  onUpdateMicOpen: (isOpen: boolean) => void;
  onUpdateCamOpen: (isOpen: boolean) => void;
}
export const useDeviceSettingModal = () => {
  const { commit } = useStore();
  const toggleModal = (isOpen: boolean, props?: DeviceSettingModalProps) => {
    commit(vuexName(MODULES.DEVICE.COMMITS.TOGGLE_DEVICE_SETTING_MODAL), {
      isOpen,
      props,
    });
  };

  return {
    toggleModal,
  };
};
